import React, { useContext, useEffect, useState } from"react";
import { UserContext } from"./UserContext";
import axios from"axios";
import { jsPDF } from"jspdf";
import { useNavigate } from"react-router-dom";
import API_BASE_URL from"./config";

const plans = [
 {
 name:"TheSkillGenie Basic",
 price: 299,
 features: ["MCQs for All Levels","TheSkillGenie Docs","SkillGenie Bot Access"]
 },
 {
 name:"TheSkillGenie Premium",
 price: 399,
 features: ["SkillGen Launchpad Docs","SkillGen Launchpad Access","SkillGenie Bot Access, Compiler"]
 }
];

const styles = {
  container: {
    backgroundColor: "var(--bg-main)",
    minHeight: "100vh",
    padding: "4rem 2rem",
    fontFamily: "Segoe UI, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    fontSize: "42px",
    fontWeight: "900",
    color: "var(--text-heading)",
    marginBottom: "3rem",
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: "2px"
  },
  grid: {
    display: "flex",
    gap: "2.5rem",
    justifyContent: "center",
    flexWrap: "wrap",
    maxWidth: "1200px"
  },
  card: {
    backgroundColor: "#FFFFFF",
    border: "1px solid var(--accent-gray)",
    borderRadius: "32px",
    width: "340px",
    padding: "2.5rem",
    color: "var(--text-body)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: "0 20px 50px rgba(31, 138, 203, 0.15)",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "hidden"
  },
  heading: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "var(--primary-blue)",
    marginBottom: "1.5rem",
    textAlign: "center"
  },
  price: {
    fontSize: "48px",
    fontWeight: "900",
    color: "var(--text-heading)",
    marginBottom: "1.5rem",
    textAlign: "center"
  },
  list: {
    listStyle: "none",
    padding: 0,
    marginBottom: "2.5rem"
  },
  listItem: {
    marginBottom: "1rem",
    fontSize: "16px",
    color: "var(--text-body)",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontWeight: "500"
  },
  button: {
    backgroundColor: "var(--primary-blue)",
    color: "#fff",
    border: "none",
    padding: "18px",
    fontWeight: "800",
    fontSize: "16px",
    borderRadius: "16px",
    cursor: "pointer",
    textTransform: "uppercase",
    transition: "all 0.3s ease",
    boxShadow: "0 10px 20px rgba(43, 176, 230, 0.3)"
  }
};

const SkillGenPaymentPage = () => {
 const { user: contextUser } = useContext(UserContext);
 const [user, setUser] = useState(contextUser || JSON.parse(localStorage.getItem("user")));
 const [receiptDoc, setReceiptDoc] = useState(null);
 const [selectedPlan, setSelectedPlan] = useState(null);
 const navigate = useNavigate();

 useEffect(() => {
 if (!user) {
 const storedUser = localStorage.getItem("user");
 if (storedUser) setUser(JSON.parse(storedUser));
 }
 }, []);

 const handlePayment = async (plan) => {
 if (!user || !user.userId) {
 alert("Please log in to continue.");
 return;
 }

 setSelectedPlan(plan);
 const { userId, name, email } = user;

 try {
 const orderResponse = await axios.post(`${API_BASE_URL}/payment/create-order`, {
 amount: plan.price,
 currency:"INR"
 });

 const { orderId, amount, currency, keyId } = orderResponse.data;

 if (!keyId) {
 alert("Failed to get Razorpay key from backend. Please try again.");
 return;
 }

 const options = {
 key: keyId,
 amount,
 currency,
 name:"TheSkillGenie",
 description: `Subscription for ${plan.name}`,
 order_id: orderId,
 handler: async function (response) {
 try {
 const verifyRes = await axios.post(`${API_BASE_URL}/payment/verify-payment`, {
 razorpay_order_id: orderId,
 razorpay_payment_id: response.razorpay_payment_id,
 razorpay_signature: response.razorpay_signature
 });

 const verifyData = typeof verifyRes.data ==="string" ? JSON.parse(verifyRes.data) : verifyRes.data;

 if (verifyData?.message !=="Payment verified successfully") {
 throw new Error("Verification failed");
 }

 const paymentData = {
 user_id: userId,
 name,
 amount: plan.price,
 payment_method:"razorpay",
 status:"success",
 transaction_id: response.razorpay_payment_id,
 opportunity:"SkillGenPro"
 };

 const storeResult = await axios.post(`${API_BASE_URL}/payment/record`, paymentData);
 const paymentInfo = storeResult.data.data;
 const expiryDate = new Date(paymentInfo.end_date);
 const reminderDate = new Date(expiryDate);
 reminderDate.setDate(expiryDate.getDate() - 7);

 // 📄 Generate PDF Receipt (Logo Left + Title Bigger)
			const doc = new jsPDF();
			const logo = new Image();
			logo.src ="/logoo.jpg"; // ✅ Ensure this image exists in public folder
			await logo.decode();

			// Header Background
			doc.setFillColor(0, 0, 0);
			doc.rect(0, 0, 210, 40, 'F');

			// 🧞 Logo on Left
			doc.addImage(logo,"PNG", 10, 8, 25, 20); // left-aligned

			// ✨ Centered Title - Larger Font
			doc.setTextColor(37, 99, 235); // Brand Blue
			doc.setFont("helvetica","bold");
			doc.setFontSize(24); // Increased from 18
			doc.text("TheSkillGenie", 105, 25, null, null, 'center');

			// Blue Section Header
			doc.setFillColor(37, 99, 235);
			doc.rect(0, 40, 210, 10, 'F');
			doc.setTextColor(255, 255, 255);
			doc.setFontSize(14);
			doc.setFont("helvetica","bold");
			doc.text("SUBSCRIPTION RECEIPT", 105, 47, null, null, 'center');

			// 📑 Receipt Details Layout
			let y = 60;
			const labelX = 25;
			const colonX = 75;
			const valueX = 85;
			const rowHeight = 10;

			const drawRow = (label, value, highlight = false) => {
			 doc.setFont("helvetica","bold");
			 doc.setTextColor(15, 23, 42); // Deep Slate
			 doc.text(label, labelX, y);
			 doc.text(":", colonX, y);
			 doc.setFont(highlight ?"bold" :"normal");
			 doc.setTextColor(highlight ? 37 : 15, highlight ? 99 : 23, highlight ? 235 : 42);
			 doc.text(String(value), valueX, y);
			 y += rowHeight;
			};

			drawRow("Receipt ID", paymentInfo.id);
			drawRow("User ID", paymentInfo.user_code);
			drawRow("Name", paymentInfo.name);
			drawRow("Amount", `₹${paymentInfo.amount}`);
			drawRow("Plan", plan.name);
			drawRow("Transaction ID", paymentInfo.transaction_id);
			drawRow("Expires On", expiryDate.toDateString());
			drawRow("Reminder On", reminderDate.toDateString());
			drawRow("Status","SUCCESS", true);

			// Footer
			doc.setDrawColor(37, 99, 235);
			doc.line(20, 270, 190, 270);
			doc.setFontSize(10);
			doc.setFont("helvetica","bold");
			doc.setTextColor(15, 23, 42);
			doc.text("© 2025 TheSkillGenie. All rights reserved.", 105, 278, null, null, 'center');
			doc.setTextColor(124, 58, 237); // Purple
			doc.text("Empowering the Future Masters", 105, 284, null, null, 'center');


 setReceiptDoc(doc);
 alert("✅ Payment Successful! Click below to download your receipt.");
 } catch (err) {
 console.error("❌ Verification/Storage Error:", err);
 alert("Payment verification failed.");
 }
 },
 prefill: { name, email, contact:"" },
 notes: { plan: plan.name },
 theme: { color:"var(--primary-blue, #4F46E5)" }
 };

 const razorpay = new window.Razorpay(options);
 razorpay.on("payment.failed", function (response) {
 console.error("❌ Payment Failed:", response.error);
 alert("Payment failed. Reason:" + response.error.description);
 });

 razorpay.open();
 } catch (err) {
 console.error("Payment error:", err);
 alert("Payment failed. Please try again.");
 }
 };

 const downloadReceipt = () => {
 if (receiptDoc) {
 receiptDoc.save("EvolveX_TheSkillGenie_Receipt.pdf");
 if (selectedPlan?.name.includes("Premium")) navigate("/dashboard");
 else navigate("/dashboard");
 }
 };

 return (
 <div style={styles.container}>
 <h2 style={styles.title}>TheSkillGenie Subscription Plans</h2>
 <div style={styles.grid}>
 {plans.map((plan, index) => (
 <div key={index} style={styles.card}>
 <h3 style={styles.heading}>{plan.name}</h3>
 <p style={styles.price}>₹ {plan.price}</p>
 <ul style={styles.list}>
 {plan.features.map((feature, idx) => (
 <li key={idx} style={styles.listItem}>{feature}</li>
 ))}
 </ul>
 <button style={styles.button} onClick={() => handlePayment(plan)}>
 Subscribe {plan.name}
 </button>
 </div>
 ))}
 </div>
 {receiptDoc && (
 <div style={{ marginTop:"2rem" }}>
 <button style={styles.button} onClick={downloadReceipt}>
 Download Receipt & Continue
 </button>
 </div>
 )}
 </div>
 );
};

export default SkillGenPaymentPage;




